

import vikram from '../Data/images/vikram.jpg'
import Bhargav from '../Data/images/bhargav.jpg'
import samshi from '../Data/images/samshi.jpg'
import Susheel from '../Data/images/susheel.jpg'
import surbhi from '../Data/images/surabhi.jpg'
import sudha from '../Data/images/shubha.jpg'
import Pallavi from '../Data/images/palavi.jpg'
import sunil from '../Data/images/sunil.jpg'
import Neha from '../Data/images/neha.jpg'
import Nitin from '../Data/images/nitin.jpg'
import Suraj from '../Data/images/suraj.jpg'
import Mayank from '../Data/images/mayank.jpg'
import harhsa from '../Data/images/harhsa.jpg'
import vishal from '../Data/images/vishal.jpg'
import kishore from '../Data/images/kishor.jpg'
import akhil from '../Data/images/akhil.jpg'

const TeamData = [
    {
        img: vikram,
        name: "S. Sri Vikram",
        branch: "Mechanical",
        domain: "Event Management",
        email: "srivikramsunkavalli@gmail.com",
       },
       {
        img: Bhargav,
        name: "Hari Bhargav",
        branch: "CSE",
        domain: "Event Management",
        mobile: 0,
        email: "haripopuri100@gmail.com",
       }, {
        img: Nitin,
        name: "Nithin Siddala",
        branch: "Biotechnology",
        domain: "Event Management",
        mobile: 0,
        email: "nithinsiddala99@gmail.com",
       }, {
        img:Suraj,
        name: "Suraj Kumar",
        branch: "MCA",
        domain: "Event Management",
        mobile: 0,
        email: "yadavsurajkumar665@gmail.com",
       }, {
        img:samshi,
        name: "Samshitha Reddy",
        branch: "Electrical",
        domain: "Event Management",
        mobile: 0,
        email: "samshithareddykarra@gmail.com",
       },{
        img:harhsa,
        name: "Harsh",
        branch: "Mechanical",
        domain: "Event Management",
        mobile: 0,
        email: "",
       }, {
        img: Susheel,
        name: "Susheel Kumar",
        branch: "Mechanical",
        domain: "Public relations",
        mobile: 0,
        email: "Susheelbanavath9908@gmail.com ",
       }, {
        img: surbhi,
        name: "Surabhi Singh ",
        branch: "Metallurgy",
        domain: "Public relations",
        mobile: 0,
        email: "singhji9685@gmail.com ",
       }, {
        img:vishal,
        name: "Vishal Singh ",
        branch: "Civil",
        domain: "Public relations",
        mobile: 0,
        email: "vishalsingh22062002@gmail.com",
       }, {
        img:sudha,
        name: "Shubhanshu",
        branch: "Chemical",
        domain: "Sponsorship",
        mobile: 0,
        email: "",
       }, {
        img: Mayank,
        name: "Mayank",
        branch: "Biotechnology",
        domain: "Sponsorship",
        mobile: 0,
        email: "",
       }, {
        img: akhil,
        name: "Akhil",
        branch: "chemical",
        domain: "Documentation",
        mobile: 0,
        email: "akhilsingamsetty225@gmail.com",
       }, {
        img: sunil,
        name: "P. Sunil Kumar",
        branch: "Mechanical",
        domain: "Design & editing",
        mobile: 0,
        email: "sunilkumarporandla360@gmail.com",
       }, {
        img: kishore,
        name: "Jeevan Kishore",
        branch: "Mechanical",
        domain: "Creatives",
        mobile: 0,
        email: "njkishore.360@gmail.com",
       }, {
        img:Pallavi,
        name: "Pallavi Sudhaker",
        branch: "Architecture",
        domain: "Creatives",
        mobile: 0,
        email: "sudhakerpallavi@gmail.com",
       }, {
        img: Neha,
        name: "Neha yednurwar",
        branch: "Mining",
        domain: "Tech",
        mobile: 0,
        email: "yednurwarneha@gmail.com",
       },
       
]

export default TeamData